import React, { } from "react";
import { useQuoteStore } from 'src/hooks/quote';
import { useAxiosIndicatorCheck } from "src/store/hook/useAxiosIndicatorCheck";

const ClearQuotePopup = (props) => {
    const { SetStatus } = props;
    const [{ }, { }, { clear_all_quote, set_is_success_action }] = useQuoteStore();
    const [__check] = useAxiosIndicatorCheck();
    const loader = __check('CLEAR_QUOTE_API_CALL').status;

    const onHide = () => {
        SetStatus(false)
    };

    const clearedAllQuote = async () => {
        const res = await clear_all_quote();
        if (res.isSuccessFull)
            set_is_success_action(true)
        onHide()
    };

    return (
        <>
            <div className="avnet-modal modal-400">
                <div className="avnet-modal-inner">
                    <button type="button" disabled={loader} className="close py-3" data-dismiss="modal"
                        onClick={onHide}>×</button>
                    <div className="modal-header border-0">
                        <h3 className="modal-title m-auto" id="exampleModalLabel"><b>Clear This Quote</b></h3>
                    </div>
                    <div className="modal-body">
                        <p className="text-center">Once cleared you will LOSE ALL ITEMS in your <br/>request for Quote.</p>
                    </div>
                    <div className="modal-footer d-flex justify-content-center">
                        <button disabled={loader} type="button" className="bs5 btn btn-secondary w145"
                            onClick={onHide}>back to quote</button>
                        <button disabled={loader} type="button" className="bs5 btn btn-primary w145"
                            onClick={clearedAllQuote}>{loader ? <i className="fa fa-spinner fa-spin" /> : 'Clear quote'}</button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ClearQuotePopup;